import { Component, Input } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";
import moment from "moment";

@Component({
    selector: "edp-widget-payment-direct-debit",
    templateUrl: "./edp-widget-payment-direct-debit.component.html",
    styleUrls: ["./edp-widget-payment-direct-debit.component.scss"]
})
export class EdpWidgetPaymentDirectDebitComponent {
    @Input() set contractSelected(contract: Contract) {
        this.contract = contract;
        this.link = [`/energia/${this.contract.ContractId}/pagamentos-faturas`];
        // this.link = [`/resumo-faturas/${this.contract.ContractId}`]; NEW INVOICE AREA
        this.dateTo = this.contract.Ird_end ?  moment(this.contract.Ird_end).subtract(1, "month").add(1, "day") : moment();
        this.dateFrom = moment(this.dateTo).subtract(1, "month").add(1, "day");
    }
    @Input() set balance(balance: any) {
        this.balanceObject = balance;
        this.value = (this.balanceObject.balance  + "");
    }
    @Input() dateLimit: moment.MomentInput;
    public contract: Contract;
    public balanceObject: { balance: string; };
    public value = "0";
    public link: string[];
    public dateFrom: moment.Moment;
    public dateTo: moment.MomentInput;

}
